import {useEffect, useRef, useState} from 'react';

// eslint-disable-next-line import/order
import {DialogContent} from '@mui/material';
import 'dayjs/locale/fr';

import useReport from '../../../../hooks/providers/useReport';
import useReportSummary from '../../../../hooks/providers/useReportSummary';
import BaseModal from '../../../modal/BaseModal';
import GenerateAnalysisForm from '../GenerateAnalysisForm/GenerateAnalysisForm';
import ReportPrivacyAlert from '../ReportPrivacyAlert/ReportPrivacyAlert';
import SummaryPromptInstructionsModal from '../SummaryPromptInstructionsModal';
import SummarySharedDataModal from '../SummarySharedDataModal/SummarySharedDataModal';
import UpdateSummaryForm from '../UpdateSummaryForm/UpdateSummaryForm';

const UpdateReportSummaryModal = () => {
  const {getSummariesData, setSummariesData, reportSummaryModalOpen: isOpen, setReportSummaryModalOpen, setUserHasConsentedToDataAnalysisByAI, setUserHasCheckedDataIsAnonymous} = useReportSummary();
  const {selectedProject: project} = useReport();

  const [isGenerateAnalysisModalOpen, setIsGenerateAnalysisModalOpen] = useState(false);

  const containerRef = useRef(null);

  const closeModal = () => {
    setReportSummaryModalOpen(false);
  };

  // const scrollToBottom = () => {
  //   const dialogContent = containerRef.current;
  //   if (dialogContent) {
  //     dialogContent.scrollTop = dialogContent.scrollHeight;
  //   }
  // };

  const resetValues = async () => {
    setUserHasConsentedToDataAnalysisByAI(false);
    setUserHasCheckedDataIsAnonymous(false);
  };

  useEffect(() => {
    (async () => {
      await resetValues();
    })();
  }, [isOpen]);

  useEffect(() => {
    (async () => {
      setSummariesData([]);
      await getSummariesData(project.siren);
    })();
  }, [project.siren]);

  return (
    <BaseModal maxWidth="md" canCloseOnBackdropClick={false} onClose={closeModal} open={isOpen} title="Créer un commentaire" hasCloseIcon>
      <DialogContent ref={containerRef} sx={{scrollBehavior: 'smooth', p: 3}}>
        <UpdateSummaryForm openGenerateAnalysisModal={() => setIsGenerateAnalysisModalOpen(true)} />

        <GenerateAnalysisForm
          open={isGenerateAnalysisModalOpen}
          onClose={() => {
            setIsGenerateAnalysisModalOpen(false);
          }}
        />
      </DialogContent>

      <ReportPrivacyAlert />

      {/* <SummaryPromptInstructionsModal /> */}

      <SummarySharedDataModal />
    </BaseModal>
  );
};

export default UpdateReportSummaryModal;
